import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import SalesAndBuyback from '../../components/SalesAndBuyback';
import Treasury from '../../components/treasury';
import SaleTransactions from '../../components/sale-transactions';
import BuybackTransactions from '../../components/buybackTransactions';
import AverageSellPrice from '../../components/averageSellPrice';
import { useTrigger } from '../../components/useTrigger';
import { services } from '../Sell/services';
import AddedBullions from '../../components/AddedBullions';

const transactions = () => {
  const [assets, setAssets] = React.useState([]);
  const { trigger, trig } = useTrigger();

  // --- آپدیت مقدار اولیه برای تطابق با ساختار جدید دیتاتیبل ---
  const [totalTodaysSell, setTotalTodaysSell] = React.useState({
    overall: {
      transactionsCount: 0,
      bullion1g: 0,
      bullion2g: 0,
      bullion5g: 0,
      bullion10g: 0,
      bullion20g: 0,
      bullion50g: 0,
      bullion100g: 0,
    },
    byBranch: [],
  });

  useEffect(() => {
    services.getInventoryStatus({}).then(assets => {
      setAssets(assets);
    });
  }, [trigger]);

  return (
    <>
      <Typography
        variant="h5"
        sx={{
          mb: 4,
          fontWeight: 700,
          color: '#111827',
          letterSpacing: '0.5px',
        }}
      >
        گزارش‌ها
      </Typography>
      <Grid
        pr={'0 !important'}
        container
        justifyContent="center"
        alignItems="center"
        sx={{
          maxWidth: '1648px',
        }}
      >
        <Grid
          container
          item
          xs={12}
          columnSpacing={{ xs: 0, md: 3 }}
          mt={'20px'}
          pt={'0 !important'}
        >
          <AddedBullions />
        </Grid>
        <Grid
          container
          item
          xs={12}
          columnSpacing={{ xs: 0, md: 3 }}
          mt={'20px'}
          pt={'0 !important'}
        >
          <SalesAndBuyback totalTodaysSell={totalTodaysSell} />
          <Treasury assets={assets} />
        </Grid>
        <SaleTransactions
          trigger={trigger}
          setTotalTodaysSell={setTotalTodaysSell}
        />

        <BuybackTransactions trigger={trigger} />
        <AverageSellPrice trigger={trigger} />
      </Grid>
    </>
  );
};

export default transactions;
